module.exports = "/_next/static/images/cc533e782c04cd67884d5d020cc3c35a-credit-card.svg.webp";